// extracted by css-extract-rspack-plugin
export default {"cls1":"PostComments-cls1_Ppg","cls2":"PostComments-cls2_Smi PostComments-cls1_Ppg"};